import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../services/api';
import './RedirectTicket.css';

// Minimal public page — no auth wrapper, no sidebar. Reached via a redirect link a
// department was emailed (Task 5); the token itself is the only credential.
export default function RedirectTicket() {
  const { token } = useParams();
  const [ticket, setTicket] = useState(null);
  const [error, setError] = useState('');
  const [authorName, setAuthorName] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await api.get(`/business/redirect/${token}`);
      setTicket(res.data.ticket);
    } catch (err) {
      setError(err.response?.data?.message || 'This link is not valid');
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!authorName.trim() || !body.trim()) return;
    setSending(true);
    try {
      const res = await api.post(`/business/redirect/${token}/comment`, { authorName, body });
      setTicket(res.data.ticket);
      setBody('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send comment');
    } finally {
      setSending(false);
    }
  };

  if (error) return <div className="redirect-page"><div className="redirect-card"><p className="redirect-error">{error}</p></div></div>;
  if (!ticket) return <div className="redirect-page"><div className="redirect-card">Loading...</div></div>;

  return (
    <div className="redirect-page">
      <div className="redirect-card">
        <div className="redirect-header">
          <span className="redirect-badge">{ticket.status}</span>
          <h1>{ticket.ticketNumber} — {ticket.title}</h1>
          <p className="redirect-meta">
            {ticket.plant?.name} · {ticket.category?.name}
            {ticket.supplier ? ` · Supplier: ${ticket.supplier.name} (${ticket.supplier.vendorCode})` : ''}
          </p>
        </div>

        <p className="redirect-description">{ticket.description}</p>

        <div className="redirect-comments">
          <h2>Comments</h2>
          {ticket.comments.length === 0 && <p className="redirect-meta">No comments yet.</p>}
          {ticket.comments.map((c, i) => (
            <div key={i} className="redirect-comment">
              <div className="redirect-comment-author">{c.author?.name || c.externalAuthorName || 'Unknown'}</div>
              <div className="redirect-comment-body">{c.body}</div>
              <div className="redirect-comment-time">{new Date(c.createdAt).toLocaleString()}</div>
            </div>
          ))}
        </div>

        <form className="redirect-form" onSubmit={handleSubmit}>
          <h2>Add a comment</h2>
          <input placeholder="Your name" value={authorName} onChange={e => setAuthorName(e.target.value)} required />
          <textarea placeholder="Your update or question..." rows={4} value={body} onChange={e => setBody(e.target.value)} required />
          <button type="submit" disabled={sending}>{sending ? 'Sending...' : 'Send comment'}</button>
        </form>
      </div>
    </div>
  );
}
